import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
    container: {
        paddingLeft: 25,
        paddingRight: 25,
    },
    contentHeaderCoin: {
        marginTop: 20,
        flexDirection: 'row',
        justifyContent: 'space-between',
        paddingHorizontal: 25
    },
    imgCoin: {
        width: 62,
        height: 62
    },
    nameCoin: {
        fontSize: 16,
        fontWeight: 'bold'
    },
    priceCoin: {
        marginTop: 20,
        fontWeight: 'bold',
        color: '#F49C16',
        fontSize: 16
    },
    titleCirculation: {
        fontSize: 10,
        fontWeight: 'bold',
        paddingVertical: 13
    },
    amountCirculation: {
        fontSize: 10,
        fontWeight: '400',
        marginTop: -4
    },
    hrLine: {
        height: 0.5,
        position: 'relative',
        borderWidth: 0.5,
        marginTop: 10,
        marginBottom: 10,
        borderColor: "#2C2C2E",
    },
    contentMore: {
        flexDirection: 'row',
        justifyContent: 'flex-end',
    },
    textMore: {
        color: '#1F26BF',
        textDecorationLine: 'underline',
        marginTop: 2,
    },
    contentTitleBottomLine: {
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    nameTitleBottomLine: {
        fontSize: 10,
        fontWeight: 'bold'
    },
    contentInfoBottomLine: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginTop: 10
    },
    InfoBottomLineVariation: {
        fontSize: 10,
        color: '#196059',
        fontWeight: 'bold'
    },
    InfoBottomLine: {
        fontSize: 10,
        color: '#2C2C2E'
    },
    contentPurchase: {
        backgroundColor: "#f1f1f1",
        paddingHorizontal: 25,
        marginTop: 20
    },
    titlePurchase: {
        textAlign: 'center',
        marginBottom: 20,
    },
    contentPurchaseAmount: {
        paddingHorizontal: 20,
        flexDirection: 'row',
        justifyContent: 'center',
    },
    hintPurchase: {
        textAlign: "center",
        paddingVertical: 5,
        color: "#666",
        fontSize: 13
    },
    numberInput: {
        flex: 1,
        backgroundColor: "#f1f1f1",
        borderWidth: 1,
        borderColor: "#ccc"
    },
    contentBtn: {
        alignItems: "center",
        marginTop: 20,
        marginBottom: 40,
    },
    btn: {
        padding: 10,
        borderRadius: 20,
        width: 200
    },
    textBtn: {
        color: '#fff',
        textAlign: 'center',
        fontSize: 14,
        fontWeight: '500',
    },
});

export default styles;
